module.exports = __webpack_public_path__ + "img/main__caption.c280cea4.svg";